<template>
<!--能耗趋势 柱状图 -->
<div class="chart-line" style="height: 145px"></div>
</template>

<script>
import * as echarts from 'echarts'
import { merge } from 'lodash'
import chartConfig from '@/utils/chartConfig'
import hexRgb from 'hex-rgb'
import { genDayList } from '@/views/sascreen/utils/genValues'

const color = ['#259fff', '#f36067', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd']

export default {
  name: 'chart-line',
  components: {},
  props: {
    datasets: Object,
    smooth: Boolean,
    fill: Boolean,
    showSymbol: Boolean,
    showLegend: Boolean,
    option: Object
  },
  mounted () {
    this.init()
  },
  watch: {
    datasets: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  methods: {
    init () {
      const chart = echarts.init(this.$el)
      window.addEventListener('resize', chart.resize)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', chart.resize)
        chart.dispose()
      })
      this.chart = chart
      this.update()
    },
    update () {
      const { datasets } = this
      const series = datasets?.series ?? []
      if(!series) return
      // const labels = this.chartData.labels
      const labels = genDayList(series[0].data.length)
      // 设置颜色
      series.forEach((item, index) => {
        item.color =  color[index]
      });
      const option = merge({}, chartConfig, {
        grid: {
          top: this.showLegend ? 40 : 10
        },
        color: series.map(item => item.color || 'rgb(0, 174, 255)'),
        legend: this.showLegend ? {
          itemWidth: 9,
          itemHeight: 2,
          right: '0%',
          top: '0',
          textStyle: {
            fontSize: 12,
            color: "#fff",
            fontFamily: 'OPPOSans R',
          },
          data: series.map(s => s.name)
        } : false,
        xAxis: {
          data: labels,
          boundaryGap: false
        },
        series: series.map(s => {
          const color = s.color || '#00aeff'
          const rgb = hexRgb(color)
          return {
            data: s.data,
            type: 'line',
            name: s.name,
            showSymbol: this.showSymbol,
            symbol: 'circle',
            symbolSize: 5,
            coordinateSystem: 'cartesian2d',
            smooth: this.smooth,
            itemStyle: {
              color,
              borderColor: s.color || '#00aeff',
              borderWidth: 2
            },
            lineStyle: { color }
          }
        })
      }, this.option)
      //option.yAxis = merge({}, chartConfig.yAxis, { data: labels, type: 'value' })
      this.chart.setOption(option)
    }
  }
}
</script>
